



































import { Component, mixins } from '@niknevis/vue-modules'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import AdminCouponEditForm from '@/modules/coupon/components/admin/forms/AdminCouponEditForm.vue'
import { Prop } from 'vue-property-decorator'
import { CouponResourceType } from '@/modules/coupon/models/coupon-resource.model'
import AdminCouponTabularHeader from '@/modules/coupon/components/admin/AdminCouponTabularHeader.vue'
import CampaignSection from '@/modules/base-campaign/components/shared/CampaignSection.vue'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import { PaginateDataMixin } from '@/modules/shared/mixins/paginate-data.mixin'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'کوپن تخفیف'
  },
  metaInfo: {
    title: 'کوپن تخفیف'
  },
  components: {
    BaseCard,
    PaginationWithInput,
    CampaignSection,
    AdminCouponTabularHeader,
    AdminCouponEditForm
  }
})
export default class AdminCouponEditPage extends mixins(PaginateDataMixin) {
  @Prop() coupon: CouponResourceType

  protected get model() {
    return this.coupon.data.campaigns
  }
}
